// extracted by mini-css-extract-plugin
module.exports = {"operation":"_1ZjUfNDX-U"};